import React, { useEffect } from "react";
import { X } from "lucide-react";

const SlideOver = ({ open, onClose, title, subtitle, children, width = "max-w-lg" }) => {
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose?.();
    if (open) document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50" data-testid="slideover">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className={`absolute right-0 top-0 h-full w-full ${width} surface animate-slide-in flex flex-col`} style={{ borderRadius: "28px 0 0 28px" }}>
        <div className="flex items-start justify-between px-7 pt-7 pb-4 border-b border-border/40">
          <div>
            <h2 className="font-serif text-2xl leading-tight">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
          <button data-testid="slideover-close" onClick={onClose}
            className="p-2 rounded-full hover:bg-muted/50 text-muted-foreground hover:text-foreground transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-7 py-6">{children}</div>
      </div>
    </div>
  );
};

export default SlideOver;
